<template>
  <div id="authorized-step">
    <authorized-form v-model="valid" ref="form"/>
    <div class="d-flex justify-content-end">
      <primary-button @click="back" :icon="faPen" class="button" white rounded-corner :text="$t('BACK')" />
      <primary-button :disabled="!valid" @click="next" :icon="faPen" class="button" rounded-corner :text="$t('NEXT')" />
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import PrimaryButton from '@/components/PrimaryButton';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import AuthorizedForm from '../../Forms/AuthorizedForm';

export default {
  name: 'AuthorizedStep',
  components: {
    AuthorizedForm,
    PrimaryButton,
  },
  setup(props, { emit }) {
    const valid = ref(false);
    const form = ref(null);

    const back = () => {
      emit('back');
      form.value.setData();
    };
    const next = () => {
      emit('next');
      form.value.setData();
    };

    return {
      valid,
      form,
      faPen,
      back,
      next,
    };
  }
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#authorized-step {
  padding: 57px 80px 33px;
  background-color: $white;
  border-radius: 8px;

  .button {
    margin-left: 20px;
    box-shadow: 0px 3px 6px $silver;
  }
}
</style>
